const translates: { [key: string]: string } = {
  // Sources
  deliveryType: "Tipo de entrega"
}

export default function __t(text: string) {
  return translates.hasOwnProperty(text) ? translates[text] : text
}
